<template>
	<div class="person">
		<div class="personPic">
			<img :src="mineUrl"/>
			<p>{{name}}</p>
		</div>
		<el-menu :default-active="active" class="el-menu-ver" :router='true'>
		  <el-menu-item index="/message/privateLetter"><img src="../assets/img/icon.png"/>
             <el-badge :value="sxnum" :max="99" :class="{ 'item': isA, 'direct': isB}">
                <span>私信记录</span>
             </el-badge>
		  </el-menu-item>
		  <el-menu-item index="/message/sendLetter"><img src="../assets/img/icon.png"/>发新私信</el-menu-item>
		  <el-menu-item index="/message/notice"><img src="../assets/img/icon.png"/>
             <el-badge :value="tznum" :max="99" :class="{ 'item': isA, 'inform': isC}">
                <span>通知</span>
             </el-badge>
		  </el-menu-item>
		</el-menu>
		<router-view class="view"></router-view>
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapGetters } from 'vuex'
	export default {
	   data(){
	  	return{
	  		active:'',
	  		picUrl:'',
	  		real_name:'',
	  		sxnum:0,
	  		tznum:0,
	  		mineUrl:'',
	  		isA:true,
	  		isB:false,
	  		isC:false
	  	}
	  },
	  computed:{
		...mapGetters([
				'imgUrl','name'
			]),
	  },
	  methods:{
	  	ifReads(){
	  		axios({
					method:'post',
					url:process.env.BASE_URL+'/notice/unread-count',
					withCredentials:true
				})
				.then(res =>{
					this.sxnum = res.data.data.letter_count 
					this.tznum = res.data.data.notice_count
					if(this.sxnum == 0){
						this.isB = true
					}else{
						this.isB = false
					}
					if(this.tznum == 0){
						this.isC = true
					}else{
						this.isC = false
					}
				})
	  	}
	  },
	   created(){
	  	axios({
	  		method:'post',
	  		url:process.env.BASE_URL+'/user/info',
	  		withCredentials:true
	  	}).then(res =>{
	  		var data = res.data.data
	  		if(res.data.data.avator == null){
		  			this.$store.commit('SET_IMGURL', '/static/admin.png')
		    } else {
		  			this.$store.commit('SET_IMGURL', process.env.PIC_URL + "/" + data.avator)
		  	}	
		  	this.mineUrl = this.$store.state.imgUrl
	  		this.$store.commit('SET_NAME', res.data.data.real_name)
	  		this.$store.commit('SET_ISPERSON', false)
			this.$store.commit('SET_ISLOGIN', false)
			this.$store.commit('SET_ISCENTER', false)
			this.$store.commit('SET_ISFIRST', true)
	  	}),
	  	this.ifReads(),
	  	setInterval(() => {
			  this.ifReads()
			},8000)
	  }
	}
</script>

<style scoped>
	.person{
		width: 1000px;
		margin: 0 auto;
		padding-top: 270px;
		
	}
	.personPic{
		width: 114px;
		height: 110px;
		position: relative;
		margin-bottom: 15px;
	}
	.personPic img{
		width: 114px;
		height: 110px;
		z-index: 10;
	}
	.personPic p{
		z-index: 20;		
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		margin: 0 auto;
		text-align: center;
		color: white;
		background-color: black;
	}
	.el-menu-ver{
		border:none;
		width: 120px;
	}
	.el-menu-ver img{
		padding-right: 10px;
	}
	.view{
		width: 850px;
		position: relative;
		margin-left: 150px;
		margin-top: -230px;
		background: #FBFBFB;
		height: 100%;
	}
	
</style>


// WEBPACK FOOTER //
// src/views/message.vue